/*jshint browserify: true */
'use strict';

var BoxDrawMode = require('./BoxDrawMode.js');

/**
 * @name AddImageMode
 */
var AddImageMode = (function AddImageModeClosure() {
    function AddImageMode(pdfElements, selectedPdfElements, pages) {
        BoxDrawMode.call(this, pdfElements, selectedPdfElements, pages);
        this.cursor = 'crosshair';
    }

    AddImageMode.prototype = Object.create(BoxDrawMode.prototype);
    AddImageMode.prototype.constructor = AddImageMode;

    AddImageMode.prototype.onMouseUp = function (mouseEvent, page) {
        if (mouseEvent.button === 0 && this._mouseIsDown === true && this._mouseStartPage === page) {
            this._mouseIsDown = false;
            this._mouseEnd = coordinates.Position.fromMouseEvent(mouseEvent, page.pageViewport, page.pdfOverlayCanvasElement);
            this._mouseEndPage = page;

            if (this._mouseStart.pdfX !== this._mouseEnd.pdfY && this._mouseStart.pdfY !== this._mouseEnd.pdfY) {
                var newElement = new PdfImageElement();
                newElement.x = this._mouseStart.pdfX < this._mouseEnd.pdfX ? this._mouseStart.pdfX : this._mouseEnd.pdfX;
                newElement.y = this._mouseStart.pdfY < this._mouseEnd.pdfY ? this._mouseStart.pdfY : this._mouseEnd.pdfY;
                newElement.width = this._mouseStart.pdfX < this._mouseEnd.pdfX ? this._mouseEnd.pdfX - this._mouseStart.pdfX : this._mouseStart.pdfX - this._mouseEnd.pdfX;
                newElement.height = this._mouseStart.pdfY < this._mouseEnd.pdfY ? this._mouseEnd.pdfY - this._mouseStart.pdfY : this._mouseStart.pdfY - this._mouseEnd.pdfY;
                newElement.pageNumber = this._mouseStartPage.pageNumber;

                this.onAddPdfElement(newElement);
            }
        }
    };

    AddImageMode.prototype.renderToCanvas = function (page, colourSettings) {
        BoxDrawMode.prototype.renderToCanvas.call(this, page);

        if (this._mouseStart !== null && this._mouseEnd !== null) {
            var elementRectangle = coordinates.Rectangle.fromPositions(this._mouseStart, this._mouseEnd, page.pageViewport);

            var img = new Image();
            img.src = imagePlaceholder.dataUriPreamble + imagePlaceholder.base64content;

            page.pdfOverlayCanvasContext.save();
            page.pdfOverlayCanvasContext.globalAlpha = 0.5;
            renderImageInCentre(img, page.pdfOverlayCanvasContext, elementRectangle.viewportLeft, elementRectangle.viewportTop, elementRectangle.viewportWidth, elementRectangle.viewportHeight, imagePlaceholder.width, imagePlaceholder.height);
            page.pdfOverlayCanvasContext.restore();
        }
    };

    return AddImageMode;
})();

module.exports = AddImageMode;

var coordinates = require('../Coordinates');
var PdfImageElement = require('../Elements/pdf-image-element.js');
var renderImageInCentre = require('../render-image-in-centre.js');
var imagePlaceholder = require('../image-placeholder.js');